import CategoryIcon from '@material-ui/icons/Category';

import CategoryList from './CategoryList';
import CategoryCreate from './CategoryCreate';
import CategoryEdit from './CategoryEdit';

export default {
    create: CategoryCreate,
    list: CategoryList,
    edit: CategoryEdit,
    icon: CategoryIcon,
};
